import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types/image';
import { classNames } from '@repo/ui/src/utils/classNames';
import Image from 'next/image';

interface Props {
  image?: ImageProps;
  aspectWidth?: number;
  aspectHeight?: number;
  imageWidth: number;
  display: boolean;
}

const OverlayImage = ({ display, image, imageWidth, aspectWidth, aspectHeight }: Props) => {
  const imageUrl = buildImageSrc(image, imageWidth, aspectWidth, aspectHeight);

  return (
    <Image
      className={classNames(
        'tw-absolute tw-h-full tw-w-full tw-object-contain tw-transition-opacity tw-transition-500 tw-ease-linear tw-pointer-events-none',
        display ? 'tw-opacity-100' : 'tw-opacity-0',
      )}
      src={imageUrl}
      fill
      alt={image?.altTag || 'Product Overlay Image'}
    />
  );
};

export default OverlayImage;
